"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");require("core-js/modules/es6.regexp.replace");
















































































































































































var _user = require("@/utils/user"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      searchData: { id: '', appId: '', name: '', visitType: '', page: 1, // 当前页码
        rows: 10 // 页码条数
      }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, newadd: false, newadd2: false, title: '新增', addData: { id: '', appId: '', name: '', remark: '', enabled: 0, enableds: '', sysType: '', packageName: '', sdkCheck: '', visitType: '', licence: '', type: '' }, defaultData: { id: '', appId: '', remark: '', enabled: 0, name: '', enableds: '', sysType: '', packageName: '', sdkCheck: '', visitType: '', licence: '', type: '' }, sysTypeList: [{ name: 'IOS', id: 1 }, { name: 'Android', id: 2 }], rules: { appId: [{ required: true, message: '请输入appId', trigger: 'blur' }], type: [{ required: true, message: '请选择类型', trigger: 'change' }], name: [{ required: true, message: '请输入应用名称', trigger: 'blur' }], visitType: [{ required: true, message: '请选择访问类别', trigger: 'blur' }], sdkCheck: [{ required: true, message: '请选择SDK验证', trigger: 'blur' }] } };}, filters: { auditStatusFilter: function auditStatusFilter(val) {if (val === '0') {return '未审核';} else if (val === '1') {return '已审核';} else {return val;}}, enabledFilters: function enabledFilters(val) {if (val === false) {return '禁用';} else if (val === true) {return '启用';} else {return val;}}, enabledsfliters: function enabledsfliters(val) {if (val === true) {return '禁用';} else if (val === false) {return '启用';} else {return val;}}, sdkCheckFilters: function sdkCheckFilters(val) {if (val === 0) {return '无需验证';} else if (val === 1) {return '需验证';} else {return val;}}, visitTypeFilters: function visitTypeFilters(val) {if (val === 0) {return '对内';} else if (val === 1) {return '对外';} else {return val;}}, sysTypeFilters: function sysTypeFilters(val) {if (val === 1) {return 'IOS';} else if (val === 2) {return 'Android';} else {return val;}}, typeFilters: function typeFilters(val) {if (val == 1) {return 'App';} else if (val == 2) {return 'H5';} else {return val;}} }, mounted: function mounted() {var self = this;self.init();}, methods: { checkPermission: _user.checkPermission, init: function init() {var self = this;self.getData('/api/faAppInfo/', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, resetFun: function resetFun() {// 重置
      this.searchData.name = '';this.searchData.appId = '';this.searchData.visitType = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;this.init();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();}, delMenu: function delMenu(item) {
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/faAppInfo/' + item.id, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    addFun: function addFun() {// 新增
      this.title = '新增';
      this.addData = JSON.parse(JSON.stringify(this.defaultData));
      this.newadd = true;
    },
    enableFun: function enableFun(item, type) {
      var self = this;
      if (item.enable === type) {
        this.$message({
          message: '当前状态相同，无需修改!',
          type: 'warning' });

        return;
      }
      self.$confirm('确定审核该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.postData('/api/faInstorage/' + item.id + '/' + 'audit', {
          enable: type },
        function (res) {
          self.$message({
            message: '修改成功!',
            type: 'success' });

          item.enable = type;
          self.init();
        });
      }).catch(function () {});
    },
    closeRefund: function closeRefund(done) {// 重置新增列表
      this.$refs['addForm'].resetFields();
      done();
    },
    onAppIdInput: function onAppIdInput(value) {
      this.$set(this.addData, 'appId', value.replace(/\s+/g, ''));
    },
    onSubmit: function onSubmit() {
      var self = this;
      if (self.addData.sdkCheck == 0) {
        self.addData.packageName = '';
        self.addData.sysType = '';
      }
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/faAppInfo', self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    updateMenu: function updateMenu(item) {
      if (item.enabled === 0) {
        this.$message({
          message: '已经启用，不能再修改!',
          type: 'warning' });

        return;
      }
      this.title = '修改';
      var self = this;

      this.addData = {
        id: item.id,
        remark: item.remark,
        enabled: item.enabled,
        name: item.name,
        packageName: item.packageName,
        sdkCheck: item.sdkCheck,
        sysType: item.sysType,
        visitType: item.visitType,
        type: item.type + '' };

      if (item.sdkCheck === '0') {
        self.addData.sdkCheck = '0';
      } else if (item.sdkCheck === '1') {
        self.addData.sdkCheck = '1';
      }
      if (item.visitType === '0') {
        self.addData.visitType = '0';
      } else if (item.visitType === '1') {
        self.addData.visitType = '1';
      }
      if (item.sysType === '1') {
        self.addData.sysType = 'IOS';
      } else if (item.sysType === '2') {
        self.addData.sysType = 'Android';
      }
      self.newadd = true;
    },
    onUpdate: function onUpdate(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          if (self.addData.sdkCheck == 0) {
            self.addData.packageName = '';
            self.addData.sysType = '';
          }
          if (self.addData.sysType === 'IOS') {
            self.addData.sysType = 1;
          } else if (self.addData.sysType === 'Android') {
            self.addData.sysType = 2;
          }
          var params = Object.assign({}, self.addData);
          params.type = parseInt(params.type);
          self.postData('/api/faAppInfo/' + params.id, params, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    onCencal: function onCencal() {
      this.newadd = false;
      this.$refs['addForm'].resetFields();
    },
    onCencal2: function onCencal2() {
      this.newadd2 = false;
      this.$refs['addForm'].resetFields();
    },
    changeappTypeFun: function changeappTypeFun(val) {
      var self = this;
      if (val === '0') {
        self.addData.enabled = '0';
      }if (val === '1') {
        self.addData.enabled = '1';
      }
    },
    auditFun: function auditFun(item, type) {
      var self = this;
      console.log('item.enabled');
      console.log(item.enabled);
      if (item.enabled === type) {
        this.$message({
          message: '当前状态相同，无需修改!',
          type: 'warning' });

        return;
      }
      self.$confirm('确定修改该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.getData('/api/faAppInfo/enableToggle/' + item.id, {}, function (res) {
          self.$message({
            message: '修改成功!',
            type: 'success' });

          item.enabled = type;
          self.init();
        });
      }).catch(function () {});
    },
    lookView: function lookView(item) {// 查看弹窗
      this.title = '查看';
      this.newadd = true;
      if (item.type == 1) {
        this.addData.privateKey = item.privateKey;
        this.addData.publicKey = item.publicKey;
      } else {
        this.addData.privateKey = item.appToken;
      }
    },
    reset: function reset(item) {
      var self = this;
      self.$confirm('确定重置公钥私钥吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.getData('/api/faAppInfo/resetKeys/' + item.id, {}, function (res) {
          self.$message({
            message: '重置成功!',
            type: 'success' });

          self.onCencal();
          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    copy: function copy(item) {
      var self = this;
      self.title = '获取licence';
      self.getData('/api/faAppInfo/sdkCheck/' + item.id, {}, function (res) {
        if (item.sdkCheck === 1) {
          self.addData.licence = res.licence;
          self.newadd2 = true;
        }
      });
    },
    copyFun: function copyFun() {
      var url = document.querySelector('#copyObj');
      url.select(); // 选择对象
      document.execCommand('Copy');
      this.onCencal2();
    },

    changeSysTypeFun: function changeSysTypeFun(val) {
      var self = this;
      self.addData.sysType = '';
      if (val === 1) {
        self.addData.sysType = 1;
      } else if (val === 2) {
        self.addData.sysType = 2;
      }
    },
    changeVisitTypeFun: function changeVisitTypeFun(val) {
      var self = this;
      self.searchData.visitType = '';
      if (val === '0') {
        self.searchData.visitType = '0';
      } else if (val === '1') {
        self.searchData.visitType = '1';
      }
    } } };exports.default = _default;